module.exports = __webpack_public_path__ + "img/schedule_img.c705c1a3.png";